import { CreateNodeShortcutCommand, NewNodeFloatingMenu } from './NewNodeFloatingMenu';
import { ExtendedReactElement } from '@/utils/types';

export const CreateNodeFloatingMenuButton = ({
	children,
	scale,
	onShortcutClick,
	setIsOpen,
}: ExtendedReactElement<{
	onShortcutClick: (shortcut: CreateNodeShortcutCommand) => void;
	scale: number;
	setIsOpen?: (open: boolean) => void;
}>) => (
	<NewNodeFloatingMenu onShortcutClick={onShortcutClick} style={{ transform: `scale(${scale})` }} setIsOpen={setIsOpen}>
		{children}
	</NewNodeFloatingMenu>
);
